import { createFileRoute, Link } from "@tanstack/react-router";
import { Phone, Mail } from "lucide-react";
import { PageShell, PageHero } from "@/components/PageShell";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/our-healthcare-network")({
  component: Network,
  head: () => ({
    meta: [
      { title: "Our Healthcare Network, Eco Park Medical & Dental Centre" },
      { name: "description", content: "N S Physiotherapy partners with GPs, psychologists, dentists and optometrists at Eco Park Medical & Dental Centre, Centurion." },
      { property: "og:title", content: "Our Healthcare Network, N S Physiotherapy" },
      { property: "og:url", content: "/our-healthcare-network" },
    ],
    links: [{ rel: "canonical", href: "/our-healthcare-network" }],
  }),
});

const team = [
  {
    role: "Psychology",
    name: "Phezile Sidwaba",
    title: "Clinical Psychologist · Practice No: 0268232",
    quals: "BA Hons Industrial Psychological Counselling (NWU); MA Clinical Psychology (Nelson Mandela University)",
    phone: "0737803662",
    email: "phezi@live.co.za",
    bio: "Over 20 years of experience supporting adolescents and adults with anxiety, depression, stress, trauma, bereavement, relationship issues, low self esteem, coping difficulties, and career guidance. Integrative approach with emphasis on CBT. Fluent in isiXhosa, isiZulu, Sesotho, Tswana, Sepedi and English.",
  },
  {
    role: "Medical",
    name: "Dr. Matube Maloba",
    title: "Medical Doctor",
    quals: "BSc, MBChB (Sefako Makgatho Health Sciences University). Postgraduate diplomas in Occupational Medicine (UP) and HIV Management (CMSA).",
    phone: "0769552477",
    email: "",
    bio: "A patient centred physician with extensive experience in clinical care. Known for focus, motivation, and strong work ethic, continuously seeking to enhance her knowledge and clinical skills to deliver high quality, compassionate care.",
  },
  {
    role: "Dentistry",
    name: "Dento Care Clinix, Tshivhula Chris & Partners",
    title: "Dr. E.T. Ndlovu (BChD, UWC 2010) · Dr. S.C. Tshivhula (BChD, MEDUNSA 1998)",
    quals: "",
    phone: "27615189283",
    email: "",
    bio: "Quality dental services delivered by a team of experienced and compassionate professionals, patient centred oral healthcare with a focus on professionalism and excellence.",
  },
  {
    role: "Physiotherapy",
    name: "Nhlamulo Khosa",
    title: "Physiotherapist · BSc Physiotherapy, UCT",
    quals: "",
    phone: SITE.phoneRaw,
    email: SITE.email,
    bio: "N S Physiotherapy is led by Nhlamulo Khosa, dedicated and qualified, helping patients restore movement, reduce pain, and improve quality of life through evidence based treatments.",
  },
];

function Network() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Coordinated care"
        title="Our healthcare network at Eco Park Medical & Dental Centre"
        subtitle="N S Physiotherapy partners with a multidisciplinary network of healthcare professionals in Centurion, GP, clinical psychologist, dentist, and optometrist, all committed to comprehensive care in one convenient location."
      />
      <section className="container-page py-16 grid gap-6 md:grid-cols-2">
        {team.map((m) => (
          <article key={m.name} className="rounded-2xl border border-border bg-card p-6 shadow-sm">
            <div className="text-xs font-semibold uppercase tracking-widest text-primary/70">{m.role}</div>
            <h2 className="mt-2 font-display text-xl font-bold text-primary">{m.name}</h2>
            <div className="text-sm text-foreground/80">{m.title}</div>
            {m.quals && <div className="mt-2 text-sm text-muted-foreground">{m.quals}</div>}
            <p className="mt-3 text-sm text-foreground/85">{m.bio}</p>
            <div className="mt-4 flex flex-wrap gap-3 text-sm">
              {m.phone && <a href={`tel:${m.phone}`} className="inline-flex items-center gap-1.5 text-primary hover:underline"><Phone className="h-4 w-4" /> {m.phone}</a>}
              {m.email && <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1.5 text-primary hover:underline"><Mail className="h-4 w-4" /> {m.email}</a>}
            </div>
          </article>
        ))}
      </section>
      <section className="container-page pb-16">
        <div className="rounded-2xl border border-border bg-secondary/60 p-6 flex flex-col md:flex-row gap-4 md:items-center justify-between">
          <div>
            <div className="font-display text-lg font-bold text-primary">Eco Park Dental and Medical Centre</div>
            <div className="text-sm text-foreground/85">Shop 11, Highveld, Eco Boulevard Shopping Centre, 270 Witch Hazel Avenue, Centurion · Open daily 07:00 – 20:00</div>
          </div>
          <div className="flex gap-2">
            <a href="tel:0120070732" className="inline-flex h-11 items-center rounded-full border border-border bg-background px-5 font-semibold text-primary hover:bg-accent">012 007 0732</a>
            <Link to="/contact" className="btn-hero inline-flex h-11 items-center rounded-full px-5 font-semibold">Contact us</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
